<script>
  import { AppController } from '../AppController';
  import { ui } from "../store.js";
  import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader
  } from "sveltestrap";
  import { createEventDispatcher } from 'svelte';

  export let account;

  const dispatch = createEventDispatcher();

  const hide = () => AppController.displayDeleteAccountModal(false);
  
  const del = () => {
    dispatch('delete', account);
    hide();
  }
</script>

<Modal isOpen={$ui.displayDeleteAccountModal} {hide}>
  <ModalHeader {hide}>Delete Account</ModalHeader>
  <ModalBody>
    This action will permantly delete the account for {account.company} and all of their data. The account and data will not be restorable.
    Are you sure you want to continue? 
  </ModalBody>
  <ModalFooter>
    <Button color="danger" on:click={del}>
      Delete
    </Button>
    <Button color="secondary" on:click={hide}>
      Cancel
    </Button>
  </ModalFooter>
</Modal>